import DisplayAddress from '~spa/classes/DisplayAddress';
import DateRangeDaysDuration from '~spa/classes/DateRangeDaysDuration';
import Contact from '~spa/api/app/contact/models/Contact';
import BaseModel from '@spa/apps/trustup-pro-base-js/models/BaseModel';
    
export default class WorksiteProfitabilityDocument extends BaseModel
{

    static getPrefix()
    {
        return 'worksite:worksite-profitability-document';
    }

    static getEndpoint(worksite)
    {
        return window.Worksite.endpoints.worksiteProfitabilityDocument.setWorksite(worksite);
    }

    getEndpoint()
    {
        return this.constructor.getEndpoint(this.currentCollection.worksite);
    }

    edit(data = {})
    {
        return super.edit({
            ...data,
            ...{
                worksite: this.currentCollection.worksite
            }
        });
    }

    getDownloadUrl()
    {
        return this.pdf;
    }

    async openExternalSource()
    {
        if ( this.external_source == 'invoicing' ) {
            window.open(
                `${window.App.$spa.apps.find(app => app.key == 'invoicing').direct_url}/redirection?route=invoices.edit&invoice=${this.external_uuid}`,
                "_blank"
            );
        }

        if ( this.external_source == 'timetracker' ) {
            let model = await window.Planning.endpoints.timeActivity.retrieve(this.external_uuid);
            if ( model ) {
                model.preview();
                return;
            }
            
            window.open(
                `${window.App.$spa.apps.find(app => app.key == 'timetracker').direct_url}`,
                "_blank"
            );
        }
    }

};